import { Logger, select } from "@fruugo/utilities";
import { ReactElement } from "jsx-dom";
import { createPictureElement } from "./utilities";
import { HomepageContent } from "../types";
import { Icon } from "./components/Icon";
import { getPromotionalTilesData } from "./api";
import { cmsMasonryImagesSizes, imageFormats } from "../config";

const Log = new Logger(window.environment);

function getPromotionalTiles() {
  const promotionsMount = select<HTMLElement>("#cms-masonry");
  if (promotionsMount === null) return;

  getPromotionalTilesData(
    cmsMasonryImagesSizes.join(","),
    imageFormats.join(",")
  )
    .then(buildPromotionalTiles)
    .then((tiles) => addTilesToDom(promotionsMount, tiles))
    .catch((error) => Log.error(error));
}

function buildPromotionalTiles(promotionalTiles: HomepageContent) {
  if (!promotionalTiles.items) return;
  const tileColumnSize = (index: number) => {
    return `${
      index <= 2 ? (index !== 2 ? "col-md-6 col-lg-4" : "col-lg-4") : "col-md-6"
    }`;
  };

  return (
    <>
      {promotionalTiles.items.map((tile, index) => (
        <a
          href={tile.cta.href}
          className={`CMS__Masonry__Item Item my-8 my-md-16 ${tileColumnSize(
            index
          )}`}
        >
          <span class="Item__Placeholder__Container">
            {createPictureElement(
              tile.imageUrl,
              tile.imageSizes,
              tile.title,
              "Item__Image"
            )}
            <span class="Item__Placeholder"></span>
          </span>
          <div class="Item__Background">
            <div class="Item__Overlay">
              <h3 class="Item__Title text-truncate">{tile.title}</h3>
              <p class="Item__Subtitle text-truncate mb-8">{tile.subtitle}</p>
              <div class="Item__Link text-truncate">
                <span class="d-flex align-items-center">
                  {tile.cta.text} <Icon name="back-arrow" aria-hidden="true" />
                </span>
              </div>
            </div>
          </div>
        </a>
      ))}
    </>
  );
}

function addTilesToDom(element: HTMLElement, tiles: ReactElement | undefined) {
  if (!element) return;

  if (tiles) {
    element.replaceChildren(tiles.cloneNode(true));
  } else {
    element.style.display = "none";
  }
}

export function initPromotions() {
  getPromotionalTiles();
}
